import { useState } from "react";
import axios from "axios";
import Config from "../../../Config";
import {
    AuthField,
    AuthForm,
    AuthFormHeader,
    AuthFormSubtitle,
    AuthFormTitle,
    AuthPrimaryButton,
} from "./AuthForm.styles";
import { color_grey_dark } from "../../../constants/colors";
import { useI18n } from "../../../i18n/I18nProvider";

const RecoveryForm = () => {
    const { t } = useI18n();
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [recoverySended, setRecoverySended] = useState(false);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsEmailValid(emailRegex.test(e.target.value));
        setError("");
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isEmailValid) {
            return;
        }

        axios
            .post(Config.BACKEND_ADDR + "/auth/recovery", {
                email: email,
                base_recovery_url: window.location.origin + window.location.pathname,
            })
            .then((response) => {
                if (response.status !== 200) {
                    alert(t("Непредвиденная ошибка при попытке восстановления пароля"));
                } else {
                    setRecoverySended(true);
                }
            })
            .catch(() => {
                alert(t("Ошибка запроса на сервер приложения"));
            });
    };

    return (
        <AuthForm onSubmit={handleSubmit}>
            <AuthFormHeader>
                <AuthFormTitle>
                    {recoverySended ? t("Данные отправлены!") : t("Забыли пароль?")}
                </AuthFormTitle>
                <AuthFormSubtitle>
                    {recoverySended
                        ? t("Если письмо не пришло, проверьте папку «Спам» или напишите в поддержку.")
                        : t("Введите email, указанный при регистрации")}
                </AuthFormSubtitle>
            </AuthFormHeader>
            {recoverySended ? (
                <p style={{ margin: 0, color: color_grey_dark, font: "400 14px/1.5 Onest, sans-serif" }}>
                    {t("Письмо отправлено на указанный адрес.")}
                </p>
            ) : (
                <>
                    <AuthField>
                        Email
                        <input
                            placeholder="example@mail.ru"
                            type="email"
                            value={email}
                            autoComplete="email"
                            onChange={handleEmailChange}
                        />
                    </AuthField>
                    {error && (
                        <p style={{ margin: 0, color: "#F04F4F", font: "400 13px/1.4 Onest, sans-serif" }}>
                            {error}
                        </p>
                    )}
                    <AuthPrimaryButton type="submit" disabled={!isEmailValid}>
                        {t("Восстановить пароль")}
                    </AuthPrimaryButton>
                </>
            )}
        </AuthForm>
    );
};

export default RecoveryForm;
